module.exports = __webpack_public_path__ + "img/yy-s1.ea523453.svg";